import React, { useEffect, useState } from "react";
import { getSettingsList, getSettingDetails, updateSettingKeyValue } from "../Services/index.js";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import PageHeading from "./Common/PageHeading.jsx";
import { Set_Upload_APK_PUT, Upload_InMultipartFile_Post } from "../api/ApiConst.js";
import { callPostApi, callPutApi } from "../api/ApiCaller.js";
import { CloseFullscreen } from "@mui/icons-material";
import { uploadFile } from "../Services/MasterServices/SettingService.js";

const Settings = () => {
    const [list, setList] = useState(null);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleOpen = () => setShow(true);
    const [settingDetails, setSettingDetails] = useState(null);
    const [toggle, setToggle] = useState(true);
    const [name, setName] = useState("test");
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, isAuth: true, title: "", subTitle: "", severity: "" });
    const [fullName, setFullName] = useState("Joe Abraham");

    const [showLoader, setShowLoader] = useState(false);

    const [bodyFormFileData, setBodyFormFileData] = useState("");
    const handleForceLogout = (data) => {
        toast("🙁" + data, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        setConfirmDialog({
            isOpen: true,
            isAuth: true,
            title: "You Are LoggedIn on Another Screen! to Countinue Logout and Login Again!!",
            onConfirm: () => logout(),
        });
    };

    const logout = () => {
        setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
        });
        const clearCookies = document.cookie.split(";").forEach((cookie) => (document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`)));
        window.location.reload(1);
    };

    const getSettingList = () => {
        getSettingsList().then((res) => {
            if (res.errorCode === 0) {
                setList(res.responsePacket);
            } else if (res.message === "Unauthorised Access") {
                handleForceLogout(res.message);
            }
        });
    };

    const handleEditSettings = (id) => {
        getSettingDetails(id).then((res) => {
            if (res.errorCode === 0) {
                handleOpen();
                setSettingDetails(res?.responsePacket);
            } else if (res.message === "Unauthorised Access") {
                handleForceLogout(res.message);
            }
        });
    };

    const handleSettingValue = (e) => {
        setSettingDetails({
            ...settingDetails,
            settingValue: e.target.value,
        });
    };

    const handleUpdate = (id, pSettingValue) => {
        let request = {
            settingValue: pSettingValue !== null ? pSettingValue : settingDetails?.settingValue,
        };

        updateSettingKeyValue(id, request).then((res) => {
            if (res.errorCode === 0) {
                toast("👏" + res.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                handleClose();
                getSettingList();
                setShowLoader(false);
                setBodyFormFileData("");
            } else if (res.message === "Unauthorised Access") {
                handleForceLogout(res.message);
                setShowLoader(false);
                setBodyFormFileData("");
            }
        });
    };

    useEffect(() => {
        getSettingList();
    }, []);


    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    {showLoader ? (
                        <div className="d-flex justify-content-center align-items-center position-absolute top-0 start-0 end-0 bottom-0">
                            <div className="spinner-border m-5 " role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <PageHeading heading={"Settings"} />
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Settings</h4>
                                            <div className="table-responsive">
                                                <table className="table mb-0 w-100">
                                                    <thead>
                                                        <tr>
                                                            <th>Setting Key</th>
                                                            <th>Setting Value</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {list &&
                                                            list.map((data, i) => {
                                                                return (
                                                                    <tr key={i}>
                                                                        <td>{data?.settingKey}</td>
                                                                        <td style={{ maxWidth: "360px" }}>{data?.settingValue}</td>
                                                                        <td>
                                                                            <a onClick={() => handleEditSettings(data?.settingKey)} className="btn btn-primary">
                                                                                Edit
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {/* end row */}
                    {/* end row */}
                </div>{" "}
                {/* container-fluid */}
            </div>
            <Modal className="tablerowmodal" show={show} onHide={() => handleClose()} size="md" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Body className="">
                    <div className="modal-header border-bottom-0">
                        <h4>Settings Update</h4>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => handleClose()}></button>
                    </div>
                    <div className="card-body">
                        <form>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label htmlFor="formrow-email-input" className="form-label">
                                            Settings Key
                                        </label>
                                        <input type="text" className="form-control" id="formrow-email-input" placeholder="Enter Full Name" value={settingDetails?.settingKey} disabled={true} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="mb-3">
                                        <label htmlFor="formrow-email-input" className="form-label">
                                            Setting Value
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="formrow-email-input"
                                            placeholder="Enter Settings Value"
                                            value={settingDetails?.settingValue}
                                            onChange={(e) => handleSettingValue(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <a className="btn btn-primary w-md" onClick={() => handleUpdate(settingDetails?.settingKey, null)}>
                                    Update
                                </a>
                                &nbsp; &nbsp;
                                <a className="btn btn-primary w-md" onClick={() => handleClose()}>
                                    Cancel
                                </a>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Settings;
